/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'random',
    initialState: {
        randomNumber: 0,
    },
    reducers: {
        setRandomNumber: (state) => {
            state.randomNumber = Math.random();
        },
    },
});

export const { setRandomNumber } = slice.actions;
export const reducer = slice.reducer;
